import { UserRoles } from "fe-common/graphql";

export const clinicRoles = [
  {
    title: "Admin",
    description: "Can manage users, customize, and view patients",
    value: UserRoles.KahunClinicManager,
  },
  {
    title: "Coordinator",
    description: "Can customize and send invite to patients",
    value: UserRoles.KahunClinicUser,
  },
];

export function getClinicRoleTitle(role: UserRoles) {
  return clinicRoles.find((r) => r.value === role)?.title;
}
